const SESSION_KEY = 'atttrack_local_auth_session'

export function getLocalSession() {
  try {
    const value = localStorage.getItem(SESSION_KEY)
    return value ? JSON.parse(value) : null
  } catch {
    return null
  }
}

export function setLocalSession(session) {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session))
}

export function clearLocalSession() {
  localStorage.removeItem(SESSION_KEY)
}

export async function refreshLocalSession(baseUrl) {
  const current = getLocalSession()
  if (!current?.refreshToken) throw new Error('No local session to refresh')
  const response = await fetch(`${baseUrl}/v1/auth/local/refresh`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${current.refreshToken}` },
  })
  if (!response.ok) {
    clearLocalSession()
    throw new Error('Local session expired')
  }
  const refreshed = await response.json()
  const session = { ...current, ...refreshed }
  setLocalSession(session)
  return session
}
